import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'true');
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'false');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div style={styles.banner}>
        <div>
            <p>Usamos cookies para melhorar sua experiência. Você aceita o uso de cookies?</p>
            <Link target="blank" to={`/pagina/termos-de-uso`}>Termos de uso</Link>
        </div>
        <div>
            <button onClick={handleAccept} style={styles.button}>Aceitar</button>
            <button onClick={handleDecline} style={styles.button}>Recusar</button>
        </div>
    </div>
  );
};

const styles = {
  banner: {
    position: 'fixed',
    bottom: 0,
    width: 'calc(100% - 20px)',
    backgroundColor: '#222',
    color: '#fff',
    padding: '10px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    zIndex: 1000,
  },
  button: {
    marginLeft: '10px',
    padding: '10px',
    cursor: 'pointer',
  },
};

export default CookieConsent;
